import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { Auth } from 'aws-amplify';

import { logintest } from '@/lib/common';
import { config } from '@/config';
import { User } from '@/@types/d';

export const FooterComponentSetup = () => {
  const currentUser = ref<User>({});
  const loggedIn = ref(false);
  const router = useRouter();
  const store = useStore();

  onMounted(() => {
    logintest(()=>{}, ()=>{}, {user:currentUser, state:loggedIn});
  });

  const signOut = () => {
    Auth.signOut();
    store.commit('removeUser');
    router.push('/');
  };
  return {
    loggedIn,
    signOut,
    footerLinks: config.FOOTER_LINKS,
    footerCopy: config.FOOTER_COPY
  };
};
